import React from 'react';
import ListingForm from '../components/listings/ListingForm';

const CreateListing: React.FC = () => {
  return <ListingForm mode="create" />;
};

export default CreateListing;
